@if (isLoading()) {
  <ag-shimmer-loader class="grow" />
} @else if (pageRows.length) {
  <!-- column selection -->
  @if (columnSelectionEnabled()) {
    <div class="mb-3 flex items-end gap-2">
      <div class="flex flex-col gap-1">
        <p-select
          [options]="unselectedColumns"
          optionLabel="heading"
          optionValue="property"
          placeholder="Add column"
          size="small"
          appendTo="body"
          [disabled]="isLoading()"
          [(ngModel)]="newColumnProperty"
          (onChange)="onAddColumn($event.value)"
        />
      </div>
      <p-button
        label="Clear"
        severity="secondary"
        size="small"
        [outlined]="true"
        [disabled]="isLoading()"
        (onClick)="clearSelections()"
      />
    </div>
  }
  <!-- column selection end -->

  <!-- table -->
  <div class="border-interface-border-100 rounded-lg border p-1">
    <p-table
      [value]="pageRows"
      [scrollable]="!!scrollHeight()"
      [scrollHeight]="scrollHeight()"
    >
      <ng-template #header>
        <tr class="whitespace-nowrap text-sm [&_th]:align-middle">
          @if (staticColumns()) {
            @for (sc of selectedColumns(); track sc) {
              <th>{{ sc.heading }}</th>
            }
          } @else {
            @for (sc of selectedColumns(); track sc; let i = $index) {
              <th class="p-1">
                <p-inputgroup>
                  @if (i > 0) {
                    <p-inputgroup-addon>
                      <button
                        severity="secondary"
                        size="small"
                        type="button"
                        pButton
                        text
                        iconOnly
                        (click)="moveColumnLeft(i)"
                      >
                        <i class="pi pi-chevron-left"></i>
                      </button>
                    </p-inputgroup-addon>
                  }
                  @if (!columnSelectionEnabled() || sc.sticky) {
                    <p-inputgroup-addon>
                      {{ sc.heading }}
                    </p-inputgroup-addon>
                  } @else {
                    <p-select
                      size="small"
                      [options]="availableColumns(sc)"
                      optionLabel="heading"
                      optionValue="property"
                      appendTo="body"
                      [ngModel]="sc.property"
                      (onChange)="onSelectedColumnChange(i, $event.value)"
                    />
                  }
                  @if (i < selectedColumns().length - 1) {
                    <p-inputgroup-addon>
                      <button
                        size="small"
                        severity="secondary"
                        type="button"
                        text
                        pButton
                        iconOnly
                        (click)="moveColumnRight(i)"
                      >
                        <i class="pi pi-chevron-right"></i>
                      </button>
                    </p-inputgroup-addon>
                  }
                  @if (columnSelectionEnabled() && !sc.sticky) {
                    <p-inputgroup-addon>
                      <button
                        size="small"
                        severity="secondary"
                        type="button"
                        text
                        pButton
                        iconOnly
                        (click)="removeSelectedColumn(sc)"
                      >
                        <i class="pi pi-times"></i>
                      </button>
                    </p-inputgroup-addon>
                  }
                </p-inputgroup>
              </th>
            }
          }
          @for (ac of aggregatedColumns(); track ac) {
            @if (!ac.hidden) {
              <th class="!text-right">{{ ac.heading }}</th>
            }
          }
          @if (enableCustomContent()) {
            <th class="w-[10%]"></th>
          }
        </tr>
      </ng-template>

      <ng-template #body let-row>
        <tr>
          @for (column of row; track column) {
            @if (!column.hidden) {
              <td
                [class.!text-right]="isAggregatedColumn(column)"
                [attr.rowspan]="column.rowspan"
              >
                {{ column.value }}
              </td>
            }
          }
          @if (enableCustomContent()) {
            <td>
              <ng-container
                [ngTemplateOutlet]="template()"
                [ngTemplateOutletContext]="{ $implicit: row }"
              />
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #footer>
        @if (selectedColumns().length > 0) {
          @for (stickyRow of stickyRows(); track stickyRow) {
            <tr class="font-semibold">
              <td [attr.colspan]="selectedColumns().length">
                {{ stickyRow.heading }}
              </td>
              @for (value of stickyRow.values; track value) {
                <td class="!text-right">
                  {{ value }}
                </td>
              }
            </tr>
          }
        }
      </ng-template>
    </p-table>
  </div>
  <!-- table end -->

  <!-- paginator -->
  @if (totalItems > 0) {
    <agx-paginator
      [totalItems]="totalItems"
      [rows]="currentItemsPerPage()"
      [first]="pageLowerBound"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="changePageSize($event)"
    />
  }
  <!-- paginator end -->
} @else {
  <div
    class="border-interface-border-100 grid h-full grow place-items-center rounded-lg border bg-white"
  >
    <div class="grid h-full w-full place-items-center gap-2 p-5">
      <div class="grid grid-cols-[2rem_1fr] place-items-center gap-3 py-5">
        <svg-icon
          class="w-fit scale-[2]"
          svgClass="text-steel-blue-500"
          src="/assets/icons/general/warning.svg"
        />
        <div class="flex flex-col gap-1">
          <h2 class="text-lg font-semibold">No data found.</h2>
          Try adjusting the filters or search criteria to view data.
        </div>
      </div>
    </div>
  </div>
}
